/* Native dialog handles modal focus containment. Purchases and the cart retain Dawn behavior. */
if (!customElements.get('shop-navigation')) {
  customElements.define('shop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-shop-menu]');
      this.openButton = this.querySelector('[data-shop-menu-open]');
      this.closeButton = this.querySelector('[data-shop-menu-close]');
      this.cartSource = this.querySelector('#cart-icon-bubble');
      if (!this.dialog || !this.openButton || !this.closeButton) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.openButton.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        this.openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('shop-menu-is-open');
        const target = this.openButton.getClientRects().length ? this.openButton : this.querySelector('.shop-header__brand');
        removeTrapFocus(target);
      }, options);
      this.breakpoint = matchMedia('(min-width: 1100px)');
      this.onResize = () => { if (this.breakpoint.matches && this.dialog.open) this.dialog.close(); };
      this.breakpoint.addEventListener('change', this.onResize);
      this.cartObserver = new MutationObserver(() => this.syncCartCount());
      if (this.cartSource) this.cartObserver.observe(this.cartSource, { childList: true, subtree: true, characterData: true });
      this.syncCartCount();
    }
    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('shop-menu-is-open');
      trapFocus(this.dialog, this.closeButton);
    }
    syncCartCount() {
      const source = this.cartSource?.querySelector('[data-shop-cart-count]');
      if (!source) return;
      const count = source.textContent.trim();
      this.querySelectorAll('[data-shop-cart-count]').forEach(node => {
        if (!this.cartSource.contains(node)) node.textContent = count;
      });
      const description = this.dataset.cartLabel.replace('__COUNT__', count);
      this.querySelectorAll('[data-shop-cart-description]').forEach(node => {
        if (!this.cartSource.contains(node)) node.textContent = description;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.cartObserver?.disconnect();
      this.breakpoint?.removeEventListener('change', this.onResize);
      if (this.dialog?.open) { removeTrapFocus(); this.dialog.close(); }
      document.body.classList.remove('shop-menu-is-open');
    }
  });
}
